// =========================================================
// * Vue Now UI Dashboard PRO - v2.2.0
// =========================================================
//
// * Product Page: http://www.creative-tim.com/product/vue-now-ui-dashboard-pro
// * Copyright 2023 Creative Tim (http://www.creative-tim.com)
//
// * Designed by www.invisionapp.com Coded by www.creative-tim.com
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import DashboardPlugin from "./dashboard-plugin";
import "@/assets/scss/lc-design-system.scss";

// CSS do Element Plus para o el-date-picker. Nunca foi importado: por isso as
// setas apareciam como caixas vazias (falta a fonte de ícones, que vem no base.css)
// e o painel sem fundo/sombra. Só o necessário ao datepicker, para não alterar o
// aspecto das tabelas/selects que já estão estilizadas pelo lc-design-system.
import "element-plus/lib/theme-chalk/base.css";
import "element-plus/lib/theme-chalk/el-date-picker.css";

// Element Plus em português (el-date-picker, etc.). Sem isto os componentes
// ficam com os textos por defeito em inglês ("Select date", "Now", "OK", ...).
import { locale as elementLocale } from "element-plus";
import elementPt from "element-plus/lib/locale/lang/pt";
// O ficheiro pt desta versão deixou os tooltips das setas em inglês; corrige-se aqui.
Object.assign(elementPt.el.datepicker, {
  prevYear: "Ano anterior",
  nextYear: "Ano seguinte",
  prevMonth: "Mês anterior",
  nextMonth: "Mês seguinte",
});
elementLocale(elementPt);

const options = { containerClassName: "ct-notification" };

const appInstance = createApp(App);
appInstance.use(router);
appInstance.use(Toast, options);
appInstance.use(DashboardPlugin);
appInstance.mount("#app");
